import React from 'react';
import PlayfulBackground from './PlayfulBackground';

const LoadingFallback = () => {
  return (
    <div className="relative min-h-screen overflow-hidden flex items-center justify-center">
      <PlayfulBackground />
      <div className="relative z-10 flex flex-col items-center gap-4 bg-white/85 rounded-3xl px-8 py-10 shadow-xl text-sky-600 max-w-sm text-center">
        <span className="text-5xl animate-bounce" role="img" aria-label="Loading" aria-hidden="true">
          🚀
        </span>
        <p className="text-xl font-semibold">Loading your mission...</p>
        <div className="flex items-center gap-2">
          <div className="w-3 h-3 bg-sky-500 rounded-full animate-pulse" style={{ animationDelay: '0ms' }} />
          <div className="w-3 h-3 bg-emerald-500 rounded-full animate-pulse" style={{ animationDelay: '150ms' }} />
          <div className="w-3 h-3 bg-amber-500 rounded-full animate-pulse" style={{ animationDelay: '300ms' }} />
        </div>
      </div>
    </div>
  );
};

export default LoadingFallback;
